<template>
	<div class="integrationListWrapper">
		<integrationsListSkeleton :items="6" :loading="loadingList" />
		<el-empty
			:image="require('../assets/empty.svg')"
			v-if="!filteredProxyList.length && !loadingList"
			description="No Integrations"
		></el-empty>
		<div v-if="!loadingList && filteredProxyList.length" :key="searchQuery" class="listWrapper">
			<LazyList
				defaultLoadingColor="#210f3c"
				:data="filteredProxyList"
				:itemsPerRender="15"
				containerClasses="list"
			>
				<template v-slot="{ item }">
					<div class="item">
						<div style="display: inline-flex; align-items: center">
							<img
								v-if="item.icon"
								class="nodeIcon"
								:src="
									`data:image/${item.iconMimeType === 'png' ? 'png' : 'svg+xml'};base64, ` + item.icon
								"
							/>
							<img v-if="!item.icon" class="nodeIcon" src="../assets/node.svg" />
							<h4>{{ item.displayName }}</h4>
						</div>
						<p>{{ item.description }}</p>
						<div class="footer">
							<el-divider></el-divider>
							<el-button
								@click="configureCredential(item)"
								v-if="item.credentials"
								style="float: right; margin-right: 20px"
								type="text"
								>Configure credentials</el-button
							>
						</div>
					</div>
				</template>
			</LazyList>
		</div>
		<regularModal
			:noBottomPadding="true"
			top="5vh"
			width="60%"
			@close="
				() => {
					showConfigureCredentialsModal = false;
				}
			"
			:visible="showConfigureCredentialsModal"
		>
			<credentialsConfigurationForm :integration="credentialOptionsForIntegration" />
		</regularModal>
	</div>
</template>

<script>
import regularModal from "./regularModal.vue";
import credentialsConfigurationForm from "./credentialsConfigurationForm.vue";
import integrationsListSkeleton from "./integrationsListSkeleton.vue";
import LazyList from "lazy-load-list/vue";
import { normalizeCredentialFields } from "../utils/normalizeFields.js";
export default {
	components: {
		regularModal,
		credentialsConfigurationForm,
		integrationsListSkeleton,
		LazyList,
	},
	props: {
		list: Array,
		searchQuery: String,
		filter: Array,
	},
	data() {
		return {
			loadingList: true,
			loadingTimeOut: 1500,
			showConfigureCredentialsModal: false,
			credentialOptionsForIntegration: [],
		};
	},
	computed: {
		filteredProxyList() {
			this.clearLoading();
			let filtered = this.list.filter((each) => {
				return each.categories.some((r) => this.filter.indexOf(r) >= 0);
			});
			filtered = this.filter.length ? filtered : this.list;
			if (this.searchQuery) {
				return filtered.filter((integration) => {
					return integration.displayName.toLowerCase().includes(this.searchQuery.toLowerCase());
				});
			}
			return [...filtered].sort((a, b) => a.displayName.localeCompare(b.displayName));
		},
	},
	watch: {
		list: function () {
			this.setLoading();
		},
		filter: function () {
			this.setLoading();
		},
	},
	methods: {
		configureCredential(integration) {
			this.showConfigureCredentialsModal = true;
			integration.credentials = normalizeCredentialFields(integration.credentials);
			this.credentialOptionsForIntegration = integration;
		},
		setLoading() {
			this.loadingList = true;
		},
		clearLoading() {
			setTimeout(() => {
				this.loadingList = false;
			}, this.loadingTimeOut);
		},
	},
};
</script>

<style scoped>
.integrationListWrapper {
	padding: 0px;
	padding-left: 20px;
}

.listWrapper {
	height: calc(100vh - 225px);
}

.list {
	padding-top: 24px !important;
	margin: 0;
	padding-left: 2px;
	display: flex;
	align-items: stretch;
	flex-wrap: wrap;
	align-content: flex-start;
	max-height: calc(100vh - 251px);
}

.integrationListWrapper /deep/ .item {
	background-color: white;
	box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
	border-radius: 4px;
	padding: 20px;
	align-items: center;
	margin-bottom: 20px;
	height: 200px !important;
	width: 250px;
	margin-right: 20px;
	position: relative;
}

.nodeIcon {
	width: 60px;
	margin-right: 10px;
}

.absoluteDivider {
	position: absolute;
	width: 291px;
	left: 0px;
	bottom: 40px;
}

.footer {
	position: absolute;
	bottom: 15px;
	right: 0px;
	width: 100%;
	height: 70px;
}

.footer /deep/ .el-divider--horizontal {
	margin-bottom: 10px;
}
</style>
